import { useState, useCallback, useEffect } from 'react';
var useHover = function () {
    var _a = useState(false), isHovering = _a[0], setIsHovering = _a[1];
    var _b = useState(null), element = _b[0], setElement = _b[1];
    //   const nodeRef = useRef<HTMLDivElement | null>(null);
    var nodeRef = useCallback(function (node) {
        setElement(node);
    }, []);
    var handleMouseOver = useCallback(function () { return setIsHovering(true); }, []);
    var handleMouseOut = useCallback(function () { return setIsHovering(false); }, []);
    var attachEventListeners = useCallback(function (node) {
        if (node) {
            node.addEventListener('mouseover', handleMouseOver);
            node.addEventListener('mouseout', handleMouseOut);
        }
    }, [handleMouseOver, handleMouseOut]);
    useEffect(function () {
        attachEventListeners(element);
        return function () {
            if (element) {
                element.removeEventListener('mouseover', handleMouseOver);
                element.removeEventListener('mouseout', handleMouseOut);
            }
        };
    }, [attachEventListeners, handleMouseOver, handleMouseOut, element]);
    return { hoverRef: nodeRef, isHovering: isHovering };
};
export default useHover;
//# sourceMappingURL=use-hover.js.map